module.exports = {"230404001":"铁西街道","230404002":"铁东街道","230404003":"六号街道","230404004":"大陆街道","230404005":"富力街道","230404006":"麓林山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230404.json
// module id = 717
// module chunks = 0